import { createContext } from 'react';

export const PizzaContext = createContext()